import EocVitalsV1 from "../../../../components/form_builder/elements/eoc_vitals/EocVitalsV1.vue";

export default {
  componentName: "fb-eoc-vitals-v1",
  component: EocVitalsV1,
  defaultAttrs: {
    properties: {
      value: ``,
      style: {},
      label: "Patient Vitals",
      description: "",
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    hidden: true,
    template: ({ value }) => value
  },
  validate: () => {
    return [];
  }
};
